export const BLOG_LOCALES = ["en", "fr", "es", "ro", "de"] as const;
export type BlogLocale = (typeof BLOG_LOCALES)[number];

export const ALTERNATE_LOCALES = ["fr", "es", "ro", "de"] as const;
export type AlternateLocale = (typeof ALTERNATE_LOCALES)[number];

export const LOCALE_LABELS: Record<BlogLocale, string> = {
  en: "English",
  fr: "Français",
  es: "Español",
  ro: "Română",
  de: "Deutsch",
};

export function isAlternateLocale(value: string): value is AlternateLocale {
  return (ALTERNATE_LOCALES as readonly string[]).includes(value);
}
